import { css } from '@emotion/core';
import { colorsPalette, hexToRgba } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

const footerBottomBarBackground = '#333333';

export const footerCss = css({
  color: colorsPalette.white,
  backgroundColor: colorsPalette.black,
});

export const topFooterSectionCss = css({
  paddingTop: 70,
  paddingBottom: 55,
  [MediaQueries.mdAndUp]: {
    paddingBottom: 70,
  },
});

export const logoLinkCss = css({
  maxWidth: 85,
  display: 'block',
  textDecoration: 'none',
});

export const logoImageCss = css({
  width: '100%',
  height: 'auto',
});

const scrollShadowBaseCss = {
  content: '""',
  backgroundImage:
    'linear-gradient(to right, rgb(57,57,57) 22%, rgba(57, 57, 57, 0.3))',
  width: 30,
  height: '100%',
  position: 'absolute',
  top: 0,
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 0.1s',
};

export const breadcrumbsShadowContainerCss = css({
  position: 'relative',

  '&:before': {
    ...scrollShadowBaseCss,
  },

  '&:after': {
    ...scrollShadowBaseCss,
    right: 0,
    backgroundImage:
      'linear-gradient(to left, rgb(57,57,57) 22%, rgba(57, 57, 57, 0.3))',
  },
});

export const displayLeftShadowCss = css({
  '&:before': {
    opacity: 1,
  },
});

export const displayRightShadowCss = css({
  '&:after': {
    opacity: 1,
  },
});

export const breadcrumbsScrollContainerCss = css({
  overflow: 'auto',
  paddingBottom: 10,
  marginTop: 18,
  marginBottom: 28,

  [MediaQueries.mdAndUp]: {
    marginTop: 10,
    marginBottom: 80,
  },

  [MediaQueries.lgAndUp]: {
    marginBottom: 65,
  },

  '::-webkit-scrollbar': {
    display: 'none',
  },
});

export const breadcrumbsContainerCss = css({
  whiteSpace: 'nowrap',
});

export const breadcrumbCss = css({
  display: 'inline-block',
});

export const breadcrumbChevronCss = css({
  fontSize: 12,
  color: colorsPalette.grey50,
  margin: '0 18px',
  lineHeight: 2,
});

export const breadcrumbItemCss = css(typography.effra14, {
  color: colorsPalette.white,
});

export const breadcrumbLinkCss = css(typography.effra14, {
  color: colorsPalette.grey20,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const downloadSectionCss = css({
  marginTop: 35,
  [MediaQueries.lgAndUp]: {
    marginTop: 0,
  },
});

export const downloadHeadlineCss = css(typography.effra28Footer, {
  marginBottom: 32,
  lineHeight: 1.18,

  [MediaQueries.lgAndUp]: {
    maxWidth: 280,
  },
});

export const storeLogosContainerCss = css({
  display: 'flex',
  flexWrap: 'wrap',
});

export const storeLogoCss = css({
  display: 'block',
  height: 40,
});

export const storeLinkCss = css({
  marginBottom: 4,
  ':first-of-type': {
    marginRight: 24,
  },
});

export const footerLowerSectionCss = css({
  marginTop: 30,
  [MediaQueries.mdAndUp]: {
    marginTop: 0,
  },
});

export const categoriesContainerCss = css({
  [MediaQueries.lgAndUp]: {
    marginTop: 6,
  },
});

export const categoryContainerCss = css({
  marginBottom: 15,
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const categoryButtonCss = css(typography.effra18, {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  fontWeight: fontWeights.medium,
  backgroundColor: colorsPalette.transparent,
  color: colorsPalette.white,
  border: 0,
  borderBottom: `1px solid ${colorsPalette.grey90}`,
  lineHeight: 1.67,
  padding: '10px 0',
  cursor: 'pointer',
});

export const categoryButtonExpandedCss = css({
  borderBottomColor: colorsPalette.transparent,
});

export const categoryHeadlineCss = css(typography.effra18, {
  fontWeight: fontWeights.medium,
  lineHeight: 1.67,
  marginBottom: 10,
});

export const categoryChevronCss = css({
  fontSize: 9,
});

export const crevronExpandedCss = css({
  transform: 'rotate(180deg)',
});

export const categoryContentCss = css({
  padding: '10px 0',
  borderBottom: `1px solid ${colorsPalette.grey90}`,
  [MediaQueries.sm]: {
    display: 'none',
  },
  [MediaQueries.mdAndUp]: {
    borderBottom: 0,
    paddingBottom: 0,
  },
});

export const categoryContentExpandedCss = css({
  [MediaQueries.sm]: {
    display: 'block',
  },
});

export const categoryLinkContainerCss = css({
  marginBottom: 12,
});

export const categoryLinkCss = css(typography.effra16, {
  color: colorsPalette.grey40,
  textDecoration: 'none',

  '&:hover': {
    color: colorsPalette.white,
  },
});

export const bottomFooterSectionCss = css({
  padding: '40px 0 15px',
  backgroundColor: footerBottomBarBackground,

  [MediaQueries.lgAndUp]: {
    padding: '15px 0',
  },
});

export const bottomFooterContentCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
});

export const generalLinksCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  flex: '0 0 100%',
  marginBottom: 30,

  [MediaQueries.mdAndUp]: {
    marginBottom: 10,
  },

  [MediaQueries.lgAndUp]: {
    flex: 1,
    marginBottom: 0,
    alignItems: 'center',
    marginLeft: 40,
  },
});

export const generalLinkContainerCss = css({
  '&:not(:last-child)': {
    marginRight: 28,
  },
});

export const generalLinkCss = css(typography.effra14, {
  color: colorsPalette.grey40,
  lineHeight: 1.7,
  textDecoration: 'none',
});

export const generalLinkHoverCss = css({
  '&:hover': {
    color: colorsPalette.white,
  },
});

export const socialMediaIcons = css({
  display: 'flex',
  marginLeft: -22,

  [MediaQueries.lgAndUp]: {
    order: -1,
  },
});

export const socialMediaIconContainerCss = css({});

export const socialMediaIconLinkCss = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: colorsPalette.white,
  textDecoration: 'none',
  width: 66,
  height: 66,
  borderRadius: '50%',
  fontSize: 20,

  '&:hover, &:focus': {
    backgroundColor: hexToRgba(colorsPalette.grey80, 0.2),
    outline: 0,
  },
});

export const languageSelectorCss = css(typography.effra14, {
  alignItems: 'center',
  alignSelf: 'center',
  backgroundColor: colorsPalette.transparent,
  border: 'none',
  cursor: 'pointer',
  color: colorsPalette.grey40,
  display: 'flex',
  textDecoration: 'none',
  maxHeight: 30,
  '&:hover': {
    color: colorsPalette.white,
  },
});

export const selectorFlagCss = css({
  display: 'inline-block',
  height: 'auto',
  lineHeight: 0,
  marginRight: 8,
  width: 20,
  img: {
    width: '100%',
  },
});

export const dropdownLabelCss = css(typography.effra14, {
  padding: 0,
  minHeight: 40,
  lineHeight: '40px',
  fontWeight: fontWeights.medium,
  backgroundColor: footerBottomBarBackground,
  color: colorsPalette.white,
  borderColor: colorsPalette.transparent,
  textTransform: 'uppercase',
});

export const dropdownIconCss = css({
  right: 0,
  color: colorsPalette.white,
});
